// redux/slices/eComproductSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  currentPage: 1,
  limit: 20,
  hasMore: true,
};

const ecomProductSlice = createSlice({
  name: "ecomProduct",
  initialState,
  reducers: {
    setProducts(state, action) {
      state.products = [...state.products, ...action.payload];
    },
    resetProducts(state) {
      state.products = [];
      state.currentPage = 1;
      state.hasMore = true;
    },
    incrementPage(state) {
      state.currentPage += 1;
    },
    setHasMore(state, action) {
      state.hasMore = action.payload;
    },
  },
});

export const { setProducts, resetProducts, incrementPage, setHasMore } =
  ecomProductSlice.actions;

export default ecomProductSlice.reducer;
